import { DEV_CONSOLE_PATH, DEVCOW_USER, PREVIEW_COORDINATOR_AVATAR_URL } from "@aquaduck/shared";
import { useDevEnv } from "../dev/env";

export function DevBanner() {
  const env = useDevEnv();
  if (!env?.devMode) return null;
  const preview = env.env === "pr";
  return <aside className={`dev-banner${preview ? " dev-banner--pr" : ""}`} aria-label="Development mode">
    <img src={preview ? PREVIEW_COORDINATOR_AVATAR_URL : DEVCOW_USER.avatarUrl} alt="Device Cow" />
    <span>You are in development mode — <strong>{env.env === "pr" ? `pr-${env.pr ?? "?"}` : "dev"}</strong></span>
    <a href={DEV_CONSOLE_PATH}>Development console <span aria-hidden="true">↗</span></a>
  </aside>;
}
